import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Button, Layout, ModalV2 as Modal } from '@utilities';

import CreditCard from './components/CreditCard';
import PlanCard from './components/PlanCard';

import { payWithCompletes, payWithCredits } from '../../../../../Checkout/utilities/constants';

const ModalLaunchMethodType = ({
  creditsTotal,
  isOpen,
  launchMethod,
  onClose,
  onConfirm,
  setLaunchMethod,
}) => {
  const userData = useSelector((state) => state?.user?.data);
  const clientInfo = userData?.clientInfo;
  const subscription = clientInfo?.subscriptionDetails?.find(
    (sub) => sub.id === clientInfo?.subscriptions?.[0]?.subscriptionId
  );

  const handleSelect = (method) => {
    setLaunchMethod(method);
  };

  return (
    <Modal
      buttons={[
        <Button key="cancel" onClick={onClose} text="Cancel" variant="secondary" />,
        <Button
          key="confirm"
          onClick={() => onConfirm(launchMethod)}
          text="Confirm"
          variant="primary"
        />,
      ]}
      isActive={isOpen}
      onClose={onClose}
      size="large"
      title="Launch Method"
    >
      <Layout.Flex>
        <PlanCard
          isSelected={launchMethod === payWithCompletes.key}
          onClick={
            subscription?.currentPeriod?.remainingCompletes <= 0
              ? undefined
              : () => handleSelect(payWithCompletes.key)
          }
          subscription={subscription}
        />
        <CreditCard
          isSelected={launchMethod === payWithCredits.key}
          onClick={creditsTotal === 0 ? undefined : () => handleSelect(payWithCredits.key)}
        />
      </Layout.Flex>
    </Modal>
  );
};

ModalLaunchMethodType.propTypes = {
  creditsTotal: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  launchMethod: PropTypes.oneOf([payWithCompletes.key, payWithCredits.key]),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  setLaunchMethod: PropTypes.func,
};

export default ModalLaunchMethodType;
